/**
 * ***********************
 * Org Routes Components *
 * ***********************
 */
const Overview = () => import('@/components/Organisations/Overview');

export default {
  title: 'Organization Details',
  path: 'overview',
  component: Overview,
  meta: {
    permission: [
      {
        action: 'view',
        entity: 'organisation'
      },
      {
        action: 'view',
        entity: 'child_organisation_details',
        type: 'dynamic'
      }
    ],
    id: 'configuration__organization-details-tab'
  },
  link: '/configuration/overview',
  permission: [
    {
      action: 'view',
      entity: 'organisation'
    },
    {
      action: 'view',
      entity: 'child_organisation_details',
      type: 'dynamic'
    }
  ]
};
